import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Supplier } from '../../../shared/models/supplier.model';
import { SessionsService } from '../../../shared/services/sessions.service';

@Component({
  standalone: false,
  selector: 'app-supplier-actions',
  templateUrl: './supplier-actions.component.html',
  styleUrls: ['./supplier-actions.component.scss'],
})
export class SupplierActionsComponent {
  currentRow: Supplier;

  constructor(private sessionService: SessionsService) {}

  agInit(params: ICellRendererParams): void {
    this.currentRow = params.data;
  }

  refresh(params: ICellRendererParams) {
    return true;
  }

  onClick(clickedItem: string) {
    this.sessionService.announceAction({ name: clickedItem, row: this.currentRow, column: 'action' });
  }
}
